import { useEffect } from 'react'

const useDocumentTitle = (title: string): void => {
  useEffect(() => {
    document.title = title + (title && ' | ') + 'GOZO Finder'
  }, [title])
}
export default useDocumentTitle
